import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["name", "id", "accept", "capture", "disabled", "webkitdirectory", "allowdirs", "directory", "multiple"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_ctx.className)
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("label", { for: _ctx.forId }, null, 8, _hoisted_1),
    (!_ctx.reload)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          ref: "input",
          type: "file",
          name: _ctx.name,
          id: _ctx.forId,
          accept: _ctx.accept,
          capture: _ctx.capture,
          disabled: _ctx.disabled,
          webkitdirectory: _ctx.iDirectory,
          allowdirs: _ctx.iDirectory,
          directory: _ctx.iDirectory,
          multiple: _ctx.multiple && _ctx.features.html5,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.inputOnChange && _ctx.inputOnChange(...args)))
        }, null, 40, _hoisted_2))
      : _createCommentVNode("", true)
  ], 2))
}